import {Injectable} from '@angular/core';
import {RestangularModule, Restangular} from 'ngx-restangular'
import { Observable } from "rxjs";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import {API_URL } from '../config';


@Injectable()
export class AssessmentStatusService {

  private baseUrl = "/api/v1"; 

  private baseUrlNew =  API_URL+"/api/v1";

  constructor(private restangular:Restangular, private http: HttpClient) {
  }

  private getHeaders(): HttpHeaders {
    const token =
      localStorage.getItem("access_token") ||
      localStorage.getItem("refresh_token");
    return new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    });
  }


  getAssessmentStatusQuiz(requestData) {
    return this.restangular.one('getAssessmentStatusQuiz').get(requestData);
  }


  getAssessmentStatusObjective(requestData) {
    return this.restangular.one('getAssessmentStatusObjective').get(requestData);
  }



  getFilteredAssesmentStatus(requestData: number): Observable<any> {
    const headers = this.getHeaders();
    // return this.http.post(`${this.baseUrl}/getFilteredAssesmentStatus`, { id: requestData }, {
      return this.http.post(`${this.baseUrlNew}/getFilteredAssesmentStatus`, { id: requestData }, {
      headers,
    });
  }

  getFilteredObjectiveStatus(requestObjective: number): Observable<any> {
    const headers = this.getHeaders();
    // return this.http.post(`${this.baseUrl}/getFilteredObjectiveStatus`, { id: requestObjective }, {
      return this.http.post(`${this.baseUrlNew}/getFilteredObjectiveStatus`, { id: requestObjective }, {
      headers,
    });
  }

}



// WEBPACK FOOTER //
// /app/src/app/services/assessment-status.service.ts